module.exports = __webpack_public_path__ + "static/carpoolchella-cta-5-77940c3d57fe1e9cccc05aa44062a821.jpg";